import React from 'react'

import { DocumentCard } from '@app/common/Components/DocumentCard/DocumentCard'
import { UploadDocumentButton } from '@app/common/Components/UploadDocumentButton/UploadDocumentButton'
import { CustomerDocument, LawyerDocument } from '@app/graphql/types'
import { bemJoin } from '@app/lib/bem'

import './DocumentsList.scss'

export type DocumentsListProps = {
  documents?: (CustomerDocument | LawyerDocument)[]
  title?: string
  mandatory?: boolean
  onAddDocument?: () => void
  onRemove?: (documentId: number, documentName?: string) => void
  disabled?: boolean
}

export const DocumentsList: React.FC<DocumentsListProps> = ({
  documents = [],
  title,
  mandatory = false,
  onAddDocument,
  onRemove,
  disabled = false
}) => {
  const b = bemJoin('documents-list')

  return (
    <div className={b()}>
      {title && (
        <div className={b('title', { mandatory, disabled })}>
          {title}
          {mandatory && <span className={b('title-label')}> (Pflicht)</span>}
        </div>
      )}

      <div className={b('documents')}>
        {documents.map((document) => (
          <DocumentCard
            key={document.id}
            document={document}
            onRemove={onRemove ? () => onRemove(document.id, document.name) : undefined}
          />
        ))}

        {onAddDocument && <UploadDocumentButton onClick={onAddDocument} disabled={disabled} />}
      </div>
    </div>
  )
}
